import { IItemCache } from '../IItemCacheObserver';
import { assign } from '../../utilities/objects';

export function bindItemCacheSelectorToProps<TResult, TProps>(
  selector: (ItemCache: IItemCache, props: TProps) => TResult,
  props: TProps
): (itemCache: IItemCache) => TResult {
  function itemCacheSelectorBoundToProps(itemCache: IItemCache): TResult {
    return selector(itemCache, props);
  }

  assign(itemCacheSelectorBoundToProps, {
    selector,
    props
  });

  return itemCacheSelectorBoundToProps;
}
